/* eslint-disable eqeqeq */
import React from 'react';
import { getRequestParams, getStartedOrders, addStartedOrder } from '../custom_views/insta_custom_views/utils_android/CookieHelper';
import { getHttpParams } from '../custom_views/insta_custom_views/utils_android/UrlHelperAndroid';
import { AppsType, getMoneyType, getSmoozieMultiplier, Pages } from '../custom_views/insta_custom_views/utils_android/UtilsAndroid';

// Перемещаем переменную внутрь компонента, так как она теперь будет использоваться через useState
const TaskItem = (props) => {
    const [readyToPerfomIds, setReadyToPerfomIds] = React.useState([]);
    const isIos = props.task.type_os == AppsType.ios
    const openTaskView = () => {
        props.onTaskClicked(props.task, (props.task.garanted_review_enable == 1 ? isIos ? Pages.task_ios : Pages.task_garanted_review : Pages.task), Pages.tasks);

    }
    const openTask = () => {
        const params = getRequestParams();
        params.order_id = props.task._id;

        fetch("https://app-coins.ru/api/readyToPerfom", getHttpParams(params))
            .then((response) => response.json())
            .then((responseData) => {
                console.log("readyToPerfom responseData = ", responseData)
                if (responseData.response === 1) {
                    setReadyToPerfomIds(prev => [...prev, {
                        id: props.task._id,
                        deleteTime: (new Date().getTime() / 1000 + 1200)
                    }]);
                    openTaskView()
                    if (!getStartedOrders().includes(props.task._id)) {
                        addStartedOrder(props.task._id);
                    }
                } else {
                    props.orderError();
                }
            });
    };

    const onTaskClicked = () => {
        let isFound = false;
        const currentTime = new Date().getTime() / 1000;

        setReadyToPerfomIds(prev => {
            const filtered = prev.filter(element => {
                if (element.id === props.task._id) {
                    isFound = true;
                }
                return currentTime < element.deleteTime;
            });
            return filtered;
        });

        if (isFound) {
            openTaskView()
        } else {
            openTask();
        }
    };

    return (
        <div className="task_item_container hover" onClick={onTaskClicked}>
            <div className="flex task_item_full_width">
                <img className="task_item_icon custom_icons_task_shadow" src={"https://" + props.task.icon} alt="" />
                <div className="block justify_content task_item_full_width">
                    <p className="task_item_title task_name_overflow">{props.task.name}</p>
                    <p className="task_item_type">{isIos ? "Задание в App Store" : props.task.type_os == AppsType.android ? "Задание в Google Play"  : "Задание в RuStore"}</p>
                    {/* <p className='task_item_price'>+{props.task.price_one_install_employer}₽</p> */}
                </div>
            </div>
            {/* {!props.isUpmob ?  */}
                <div className="task_item_money_c flex">+{props.task.price_one_install_employer * getSmoozieMultiplier()}<span>{getMoneyType(props.isUpmob)}</span></div>
            {/* :
                <p className="task_item_money_c">+{props.task.price_one_install_employer}₽</p>
            } */}
        </div>
    );
};

// React.memo: элемент списка перерисовывается только при смене своих props,
// а не на каждое обновление баланса/таймера в родителе.
export default React.memo(TaskItem);